import * as angular from 'angular';

import { IRequestService } from '../request.service';

export interface IRolesService {
    getAll(): angular.IPromise<{ id: string, name: string }[]>;
}

export class RolesService implements IRolesService {

    static serviceId = 'rolesService';
    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<{ id: string, name: string }[]> {
        return this._requestService.getAtV1('roles');
    }
}